import { render } from "./BuyOrderSummaryComponent.vue?vue&type=template&id=5ec25557&ts=true"
import script from "./BuyOrderSummaryComponent.vue?vue&type=script&lang=ts"
export * from "./BuyOrderSummaryComponent.vue?vue&type=script&lang=ts"

import "./BuyOrderSummaryComponent.vue?vue&type=style&index=0&id=5ec25557&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/BuyOrderSummaryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ec25557"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ec25557', __exports__)) {
    api.reload('5ec25557', __exports__)
  }
  
  module.hot.accept("./BuyOrderSummaryComponent.vue?vue&type=template&id=5ec25557&ts=true", () => {
    api.rerender('5ec25557', render)
  })

}


export default __exports__